import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "MoveEnrolmentsToHistory" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "MoveEnrolmentsContainer" }
const _hoisted_6 = { class: "MoveToHistoryButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCollapsed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isMoveEnrolmentAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "MoveEnrolmentsTitle" }, "Move to:", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expand())),
                  class: "NavigatorButton MoveEnrolmentsButton"
                }, " History ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[5] || (_cache[5] = [
                _createElementVNode("p", { class: "MoveEnrolmentsTitle" }, "Move to:", -1 /* CACHED */),
                _createElementVNode("div", { class: "NotAvailableWarning" }, [
                  _createElementVNode("i", { class: "lnr-clipboard-alert WarningIcon" }),
                  _createElementVNode("p", { class: "WarningText" }, " Selected enrolments cannot be moved to History. Please revise your selection and try again. ")
                ], -1 /* CACHED */)
              ])))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapse())),
            class: "ExitButton TransitionBackButton"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "lnr-arrow-left BackArrow" }, null, -1 /* CACHED */)
          ])),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Move the selected enrolment(s) to:", -1 /* CACHED */)),
            _cache[8] || (_cache[8] = _createElementVNode("strong", { class: "MoveEnrolmentsDestination" }, "History", -1 /* CACHED */)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "WarningContainer" }, [
              _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }),
              _createTextVNode(" Please note these enrolments will be permanently moved to history and you cannot move them back. ")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "DriverButton PrimaryButton",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMoveConfirmed()))
              }, " Ok "),
              _createElementVNode("button", {
                class: "ExitButton CancelButton",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onMoveCanceled()))
              }, " Cancel ")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}